import React from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

const DataTable = (props) => {
	const {
		id,
		title = '',
		data = [],
		columns = [],
		options,
		showDownload = false,
		showPrint = false,
		selectableRows = 'none',
		rowsPerPage = 20,
		filterType = 'multiselect',
		tableBodyMaxHeight = '40em',
		totalCount,
		page,
		onChangePage,
		onChangeRowsPerPage,
		...rest
	} = props;

	const getMuiTheme = () => {
		const { tableBodyCellMaxWidth, actionColumnWidth } = props;

		return createTheme({
			components: {
				MuiTableRow: {
					styleOverrides: {
						root: {
							'&:nth-of-type(odd)': {
								backgroundColor: '#f2f2f2',
							},
						},
					},
				},
				MuiTableCell: {
					styleOverrides: {
						head: {
							backgroundColor: '#1565c0 !important',
							fontWeight: 'bold',
							color: 'white',
							paddingRight: 2,
							paddingTop: 2,
							paddingBottom: 2,
							fontSize: 12,
						},
						body: {
							maxWidth: tableBodyCellMaxWidth,
							'&:last-child': {
								width: actionColumnWidth,
							},
							paddingRight: 2,
							paddingTop: 2,
							paddingBottom: 2,
							fontSize: 14,
						},
					},
				},
			},
		});
	};

	const _onRowSelection = (currentRowsSelected, allRowsSelected, rowsSelected) => {
		const { onRowSelection } = props;
		const selectedRows = data.filter((dt, index) => rowsSelected.includes(index));
		onRowSelection(selectedRows);
	};

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={getMuiTheme()}>
				<div id={id}>
					<MUIDataTable
						key={id}
						title={title}
						data={data}
						columns={columns}
						options={{
							serverSide: true,
							count: totalCount,
							page: page,
							rowsPerPage: rowsPerPage,
							onChangePage: onChangePage,
							onChangeRowsPerPage: onChangeRowsPerPage,
							tableBodyMaxHeight,
							rowsPerPageOptions: [10, 15, 20, 100],
							filterType,
							download: showDownload,
							print: showPrint,
							selectableRows,
							responsive: 'standard',
							rowsPerPage,
							onRowSelectionChange: _onRowSelection,
							...options,
						}}
						{...rest}
					/>
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

DataTable.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string,
	data: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	options: PropTypes.object,
	showDownload: PropTypes.bool,
	showPrint: PropTypes.bool,
	selectableRows: PropTypes.string,
	rowsPerPage: PropTypes.number,
	filterType: PropTypes.string,
	tableBodyCellMaxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	actionColumnWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onRowSelection: PropTypes.func,
	tableBodyMaxHeight: PropTypes.string,
};

export default DataTable;
